export const ToggleButtonWidgetId = 'ToggleButtonWidget';

export enum ToggleButtonWidgetAttributes {
  LABEL = 'label',
  VALUE = 'value',
  DISABLED = 'disabled',
}
